import {Col, Row, Form, Button} from "react-bootstrap";
import React, {useState} from "react";
import Back from "../layout/template/back";
import UserForm from "../form/userForm";
import ApiService from "../../services/ApiService";
import {useNavigate} from "react-router-dom";
import AppRoute from "../../utils/AppRoute";
import GenericErrorModal from "../modal/genericErrorModal";

const messagePrivacy = 'Messaggio per la riservatezza dei dati dei clienti*\n' +
    'I dati personali che ci fornisci sono utilizzati per rispondere alle tue domande, elaborare gli ordini o consentire l’accesso a informazioni specifiche. Hai il diritto di modificare e cancellare tutte le informazioni personali che si trovano nella pagina “Il mio Account”.'

const messageNewsletter = 'Iscriviti alla nostra newsletter\n' +
    'Puoi annullare l’iscrizione in ogni momento. A questo scopo, cerca le info di contatto nelle note legali.'

const Registration = () => {

    const navigate = useNavigate()
    const [titolo, setTitolo] = useState()
    const [email, setEmail] = useState()
    const [nome, setName] = useState()
    const [cognome, setCognome] = useState()
    const [password, setPassword] = useState()
    const [passwordConfirmation, setPasswordConfirmation] = useState()
    const [privacy, setPrivacy] = useState(false)
    const [newsletterSubscription, setNewsletterSubscription] = useState(false)
    const [partnerOffer, setPartnerOffer] = useState(false)
    const [showRegistrationAlert, setShowRegistrationAlert] = useState(false);
    const [registrationAlertContent, setRegistrationAlertContent] = useState({})

    const handleRegistration = (event) => {
        event.preventDefault()

        if (titolo && email && nome && cognome && password && passwordConfirmation && (password === passwordConfirmation) && privacy) {
            //POPUP O EVIDENZIARE FLAG NECESSARIO
            let requestParams = {
                title: titolo,
                email: email,
                firstName: nome,
                lastName: cognome,
                password: password,
                privacy: privacy,
                newsLetter: newsletterSubscription,
                partnerOffer: partnerOffer
            }

            ApiService.createUser(requestParams).then((response) =>{
                if(response.ok){
                    navigate(AppRoute.REGISTRATION_SENT)
                }else if(response.status === 409){
                    setRegistrationAlertContent({
                        title: "Account Già Registrato",
                        body: "Continua"
                    })
                    setShowRegistrationAlert(true);
                } else {
                    setRegistrationAlertContent({
                        title: "Errore nella crezione dell'account",
                        body: "Riprovare"
                    })
                    setShowRegistrationAlert(true);
                }
            })
        }
    }

    const isFormValid = () => {
        // Add any other validation logic you need here
        return (
            titolo!== '' &&
            email !== '' &&
            nome !== '' &&
            cognome !== '' &&
            password !== '' &&
            passwordConfirmation !== '' &&
            privacy
        );
    };


    const handleCloseRegistrationAlert = () => setShowRegistrationAlert(false)

    return (
        <>
            <Row>
                <Col lg={6}>
                    <Row>
                        <Col>
                            <Back/>
                        </Col>
                    </Row>

                    <Row className={'mt-5 mb-2'}>
                        <Col>
                            <h2 className={'fw-bold'}>Nuovo account</h2>
                        </Col>
                    </Row>

                    <Row className={'mb-5'}>
                        <Col>
                            <Form>

                                <UserForm setTitle={setTitolo} title={titolo} setName={setName} name={nome} setEmail={setEmail}
                                          setCheckPassword={setPasswordConfirmation} setPassword={setPassword}
                                          setSurname={setCognome} surname={cognome}/>

                                <div key={`default-checkbox`} className="mb-3 mt-5">
                                    <Form.Check
                                        required
                                        label={messagePrivacy}
                                        id={`data`}
                                        type="checkbox"
                                        className={'linebreak'}
                                        onChange={() => setPrivacy(!privacy)}
                                    />
                                    <Form.Check
                                        label={messageNewsletter}
                                        type="checkbox"
                                        id={`newsletter`}
                                        className={'linebreak'}
                                        onChange={() => setNewsletterSubscription(!newsletterSubscription)}
                                    />
                                    <Form.Check
                                        label={'Ricevi offerte dai nostri partner'}
                                        type="checkbox"
                                        id={`sales`}
                                        onChange={() => setPartnerOffer(!partnerOffer)}
                                    />
                                </div>

                                <p className={'mt-1'}>*campi obbligatori</p>


                                <div className={'w-100 d-flex justify-content-end'}>
                                    <Button variant={'primary'} type={'submit'} disabled={!isFormValid()}
                                            onClick={(e) => handleRegistration(e)}
                                            className={'px-5 fw-bold'}>Registrati</Button>
                                </div>

                                <GenericErrorModal handleClose={handleCloseRegistrationAlert} contentText={registrationAlertContent} showModal={showRegistrationAlert}/>
                            </Form>
                        </Col>
                    </Row>

                </Col>
            </Row>
        </>

    );
}

export default Registration;
